// Import npm packages
var $ = require('jquery');
require('dom-slider');
const {slideDown, slideUp, slideToggle} = window.domSlider;

// Global Exports
window.$ = $ || {}

// Init site components
require('./components/swiper');
require('./components/pagination');
require('./components/animation');

// We are ready
$(document).ready(function() {
	
	// Initialize components
	window.pagination.init();
	window.animation.init();

	// On window scroll
	let lastScrollTop = 0;
	$(window).scroll(function(event) {
		let scrollTop = $(this).scrollTop();

		// If scrolled past 60 pixels
		if (scrollTop > 5) {
			// Fix the header
			$('.navigation .fixed').addClass('floating');
		}
		else {
			// Unfix the header
			$('.navigation .fixed').removeClass('floating');
		}

		// If scrolling down
		if (scrollTop > lastScrollTop) {
			// Hide the header
			$('.navigation .fixed').removeClass('active');
		} 

		// If scrolling up
		else {
			// Show the header
			$('.navigation .fixed').addClass('active');
		}

		lastScrollTop = scrollTop;
	});

	// Activate scroll events
	$(window).scroll();

	// Hero Banner - Show Random Image From Gallery
	if ($('.hero .image.gallery').length) {
		$('.hero .image.gallery').each(function() {
			var numImages = $('img', this).length;
			var randomIndex = Math.floor(Math.random() * numImages);
			var randImage = $('img', this).eq(randomIndex);
			
			if (randImage.length) randImage.show();
			else $('img', this).eq(0).show();
		});
	}

	// Header Banner
	$('.header-banner').each(function() {
		var id = $(this).attr('data-id');
		var banner = getCookie(id);
		if (!banner) {
			$(this).slideDown('slow');
		}
	});

	// Dismiss Header Banner
	$('.header-banner .close-button').on('click', function(){
		var parent = $(this).closest('.header-banner');
		var id = parent.attr('data-id');

		setCookie(id, 1, 30);

		$('.header-banner').each(function() {
			$(this).slideUp();
		});
	});

	// Cookie Banner
	var cookieAgreement = getCookie('accepted-cookie-agreement');
	if (!cookieAgreement) {
		$('.cookie-banner').fadeIn('slow');
	}

	// Dismiss Cookie Banner
	$('.cookie-banner .ok-button').on('click', function(){
		setCookie('accepted-cookie-agreement', 1, 30);
		var parent = $(this).closest('.cookie-banner');
		parent.fadeOut();
	});

	// Animate buttons
	$('body').on('mouseenter', '.button .inner', function(e) {
		var parentOffset = $(this).offset(); 
		var relX = e.pageX - parentOffset.left;
		var relY = e.pageY - parentOffset.top;
		$(this).prev('.circle').css({'left': relX, 'top': relY });
		$(this).prev('.circle').removeClass('desplode');
		$(this).prev('.circle').addClass('explode');
	});
	$('body').on('mouseleave', '.button .inner', function(e) {
		var parentOffset = $(this).offset(); 
		var relX = e.pageX - parentOffset.left;
		var relY = e.pageY - parentOffset.top;
		$(this).prev('.circle').css({'left': relX, 'top': relY });
		$(this).prev('.circle').removeClass('explode');
		$(this).prev('.circle').addClass('desplode');
	});

	// View more details button on Claim Forms
	$('body').on('click', '.claim-form .detail-cta', function() {
		var parent = $(this).closest('.details');
		var content = parent.find('.content');

		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			content.slideUp();
		}
		else {
			$(this).addClass('active');
			content.slideDown();
		}
	});

	// Load Claim Forms on page load if block exists
	if ($('.claim-archive').length) {
		updateClaimArchive();
	}

	// Claim Archive - Change category dropdown
	$('.claim-archive .filters select').on('change', function() {
		var taxQuery = null;
		var taxonomy = $(this).attr('name');
		var term = $('option:selected', this).val();

		// Un-select all other category dropdowns
		$('.claim-archive .filters select:not([name="'+taxonomy+'"]) > option:eq(0)').prop('selected', true);

		// Get the query
		if (term) {
			taxQuery = [{
				taxonomy: taxonomy,
				field: 'slug',
				terms: term,
				operator: 'IN',
			}];
		}

		updateClaimArchive(taxQuery);
	});

	// Claim Archive - Reset filters
	$('.claim-archive .filters .reset').on('click', function() {
		if ($('.claim-archive .filters select[name="product_category"] > option:eq(0)').is(':selected') && 
		    $('.claim-archive .filters select[name="form_category"] > option:eq(0)').is(':selected')) {
			return false;
		}
		
		$('.claim-archive .filters select > option:eq(0)').prop('selected', true);
		$('.claim-archive .filters select').trigger('change');
	});

	// Share button popup
	if ($('.claim-archive').length) {
		$('body').on('click', function(e) {

			// Clicking on a share button
			if (e.target.classList.contains('share-button')) {
				if ($(e.target).hasClass('active')) {
					$(e.target).removeClass('active');
				}
				else {
					// Close other open popups when opening a new one
					$('.share-links .share-button').removeClass('active');
					$(e.target).addClass('active');
				}
			}

			// Clicking off somewhere else
			else {
				// Close all instances of open share popups
				if ($('.share-links .share-button').hasClass('active')) {
					$('.share-links .share-button').removeClass('active');
				}
			}
		});
	}

	// Submit gated form
	$('.gated-form-submit').on('click', function(e) {
		e.preventDefault();
		var form = $('#gated-form');
		if (!form.length) return false;
		form.submit();
	}); 

	// Scroll to gated form if it has errors
	if ($('.gated-form.has-errors').length) {
		$('html, body').animate({
			scrollTop: $('.gated-form.has-errors form').offset().top - 100,
		}, 0);
	}

	// Open mobile nav menu
	$('.mobile-nav .hamburger-button').on('click', function() {
		var nav = $(this).closest('.mobile-nav');
		var buttons = $(this).closest('.menu-button');
		var closeButton = $('.close-button', buttons);
		var mobileMenu = $('.mobile-menu-container');
		var mobileNav = mobileMenu.find('.nav');

		nav.addClass('active');
		$(this).hide();
		closeButton.fadeIn();
		mobileMenu.slideDown(100, function() {
			mobileNav.addClass('active');
		});
	});

	// Close mobile nav menu
	$('.mobile-nav .close-button').on('click', function() {
		var nav = $(this).closest('.mobile-nav');
		var buttons = $(this).closest('.menu-button');
		var hamburgerButton = $('.hamburger-button', buttons);
		var mobileMenu = $('.mobile-menu-container');
		var mobileNav = mobileMenu.find('.nav');

		nav.removeClass('active');
		$(this).hide();
		hamburgerButton.fadeIn();
		mobileMenu.slideUp(100, function() {
			mobileNav.removeClass('active');
		});
	});

	// Hide mobile sub-menus
	var subMenu = $('.mobile-nav .main-nav .menu .sub-menu');
	subMenu.hide();

	// Prevent parent menu item link 
	var menuLink = $('.mobile-nav .main-nav .menu > ul > li.has-submenu > .text-mobile-main-nav > a');
	menuLink.click(function(event) {
    	event.preventDefault();
	});

	// Toggle mobile sub-menus
	$('.mobile-menu-container > .wrapper > .nav > .main-nav > .menu > ul > li.has-submenu').on('click', function(e) {
		var subMenuItems = $(this).children('.sub-menu');
		var submMenuLi = $('.sub-menu > li');
		var caret = $('.has-submenu .caret');
		$(this).find('.sub-menu').slideToggle();

    	// Close
		if ($(this).hasClass('show')) {
			$(this).removeClass('show');
			caret.removeClass('up');
		}

		// Open
		else {
			$(this).addClass('show');
			caret.addClass('up');
		}
	});

	//Prevent sub-menu toggle on submenu li's
	$(".no-toggle > .text-mobile-main-nav > a").click(function(e){
		e.stopPropagation(); 
	});

	// Open and close homepage hero 'You' dropdown when clicked
	$('.hero .select').on('click', function() {
		var options = $('.options');
		var caretDown = $(this).find('.caret-down-rounded');

		// Close 
		if (options.hasClass('active')) {
			options.slideUp('fast');
			options.removeClass('active');
			caretDown.removeClass('up');
		}

		// Open
		else {
			options.addClass('active');
			options.slideDown('fast');
			caretDown.addClass('up');
		}
	});

	// Show and hide search form when search icon is clicked on mobile 
	$('.mobile-nav .search-button').on('click', function() {
		var form = $('.search-form form');

		form.toggleClass('desktop-tablet');
	});

	// Close you dropdown when clicking elsewhere on page
	$(document).on("click", function(event){
        var $trigger = $('.hero .select');
        var options = $('.hero .dropdown .options');
        var caretDown = $('.hero .caret-down-rounded');

        if ($trigger !== event.target && !$trigger.has(event.target).length){
            options.removeClass('active');
            options.slideUp('fast');
            caretDown.removeClass('up');
        }
    });

	// Open or close accordion menu
	$('.accordion .section .section-header').on('click', function() {
		var section = $(this).closest('.section');

		// Exit early if already animating
		if (section.hasClass('sliding')) return false;

		var body = section.find('.section-body');

		// Close
		if (section.hasClass('active')) {
			section.addClass('sliding');
			slideUp({element: body[0], slideSpeed: 600}).then(() => {
				section.removeClass('active').removeClass('sliding');
			});
		}

		// Open
		else {
			section.addClass('sliding');
			slideDown({element: body[0], slideSpeed: 600}).then(() => {
				section.addClass('active').removeClass('sliding');
			});
		}
	});
	
	// Swiper buttons for the gallery block
	$('.gallery .swiper-buttons .next, .gallery .swiper-buttons .prev').on('click', function() {
		var parent = $(this).closest('.gallery');
		var slider = parent.find('.background-swiper')[0].swiper;

		if ($(this).hasClass('next')) { slider.slideNext(); }
		if ($(this).hasClass('prev')) { slider.slidePrev(); }
	});

	// Sync background and foreground sliders
	window.swiper1.on('slideNextTransitionStart', function() {
		window.swiper2.slideNext(300, false);
	});
	window.swiper1.on('slidePrevTransitionStart', function() {
		window.swiper2.slidePrev(300, false);
	});
	window.swiper2.on('slideNextTransitionStart', function() {
		window.swiper1.slideNext(300, false);
	});
	window.swiper2.on('slidePrevTransitionStart', function() {
		window.swiper1.slidePrev(300, false);
	});
	window.swiper2.on('slideChange', function(swiper) {
		var captionText = $('.foreground-swiper .swiper-slide[data-swiper-slide-index='+swiper.realIndex+'] img').attr('data-caption');
		$('.block.gallery .caption span').hide().text(captionText).fadeIn();
	});

	// Swiper buttons for the testimonial block
	$('.testimonials .swiper-buttons .next, .testimonials .swiper-buttons .prev').on('click', function() {
		var parent = $(this).closest('.testimonials');
		var slider = parent.find('.background-swiper-testimonial')[0].swiper;

		if ($(this).hasClass('next')) { slider.slideNext(); }
		if ($(this).hasClass('prev')) { slider.slidePrev(); }
	});

	// Sync background and foreground sliders
	window.swiper3.on('slideNextTransitionStart', function() {
		window.swiper4.slideNext(300, false);
	});
	window.swiper3.on('slidePrevTransitionStart', function() {
		window.swiper4.slidePrev(300, false);
	});
	window.swiper4.on('slideNextTransitionStart', function() {
		window.swiper3.slideNext(300, false);
	});
	window.swiper4.on('slidePrevTransitionStart', function() {
		window.swiper3.slidePrev(300, false);
	});
});

/**
 * Set a cookie that expires after specified amount of days
 * From: https://www.w3schools.com/js/js_cookies.asp
 */
function setCookie(cookie_name, cookie_value, expire_in_days) {
	var date = new Date();

	date.setTime(date.getTime() + (expire_in_days*24*60*60*1000));
	var expires = "expires="+ date.toUTCString();

	document.cookie = cookie_name + "=" + cookie_value + ";" + expires + ";path=/";
}

/**
 * Get a cookie back from cookie storage
 * From: https://www.w3schools.com/js/js_cookies.asp
 */
function getCookie(cookie_name) {
	var name = cookie_name + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');

	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];

		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}

		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}

	return "";
}

/**
 * Update the Claim Archive listings
 */
function updateClaimArchive(taxQuery = null) {
	var parent = $('.claim-archive');
	if (!parent.length) return false;
	var container = parent.find('.forms');
	if (!container.length) return false;

	// Remove existing items in the container
	container.empty();

	// Show loading
	parent.find('.loading').addClass('active');

	// Grab the forms via Ajax
	$.ajax({
		type: 'POST',
		url: ajaxurl,
		dataType: 'json',
		data: { 
			action: 'get_forms',
			tax_query: taxQuery,
		},
		success: function(response) {
			// Error message
			if (!response.success) {
				console.log(response.message);
				return false;
			}

			var data = response.data;

			// Show no data message
			if (!data.length) {
				container.append('<div class="well">No Claim Forms found for the current filters.</div>');
			}

			// Loop through the data
			else {
				for (var i = 0; i < data.length; i++) {
					var item = data[i];

					// Create a div for each item
					var $item = $(item.html);
					container.append($item);
				}
			}

			// Hide loading
			parent.find('.loading').removeClass('active');

			// Update AJAX pagination
			window.pagination.setTotal(data.length);
			window.pagination.update();
		}
	});
}